
import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center cursor-pointer px-1 py-2 sm:py-1.5",
      className
    )}
    data-custom-name="slider-root"
    {...props}
  >
    <SliderPrimitive.Track className="relative h-5 sm:h-4 w-full grow overflow-hidden rounded-full bg-gray-700 border border-gray-600" data-custom-name="slider-track">
      <SliderPrimitive.Range className="absolute h-full bg-indigo-600" data-custom-name="slider-range" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-8 w-8 sm:h-7 sm:w-7 rounded-full border-2 border-indigo-600 bg-gray-200 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer hover:border-indigo-400 hover:bg-white transition-all duration-300 hover:scale-110 shadow-md" data-custom-name="slider-thumb" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
